module.exports = __webpack_public_path__ + "img/fi-rr-minus-small.85a3e6dc.svg";